<template>
  <!-- 标签 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="tag"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">设置标签</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">已设置</div>
          <div class="form-group">
            <div class="tag clearfix">
              <div class="list" v-for="tag in tags" :key="tag.tag_number">
                <p>{{ tag.tag_name }}</p>
                <i class="iconfont icon-close" @click="removeTag(tag)"></i>
              </div>
            </div>
          </div>
          <div class="form-group">添加新标签</div>
          <div class="form-group">
            <textarea
              class="form-control"
              placeholder="添加标签，多个标签用 | 隔开"
              style="resize: vertical"
              rows="5"
              v-model.trim="newTags"
            ></textarea>
            <span class="help-block" v-show="errors.has('singleTag')">{{
              errors.first("singleTag")
            }}</span>
          </div>
          <div class="form-group">从现有标签中选择</div>
          <div class="form-group">
            <div class="tag clearfix">
              <div class="list" v-for="tag in tagList" :key="tag.id">
                <p>{{ tag.tag_name }}</p>
                <i class="iconfont icon-plus" @click="addTag(tag)"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" type="button" @click="close">
            取消
          </button>
          <button class="btn btn-primary" type="button" @click="addTags">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyTagname } from "@/utils/verify";
import {
  resourceTagList,
  resourceTagAllList,
  handleResourceTag,
} from "@/api/drive/tag";
export default {
  name: "TableTag",
  props: {
    detail: {
      type: Object,
    },
  },
  data() {
    return {
      existTags: [],
      newTags: "",
      tags: [],
      tagList: [],
    };
  },
  computed: {
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
  },
  methods: {
    close() {
      this.errors.remove("singleTag");
      this.tagList = [];
      this.existTags = [];
      $("#tag").modal("hide");
    },
    // 获取文件(夹)标签
    resourceTagList() {
      resourceTagList({
        resource_number: this.detail.number,
        group_number: this.groupNumber,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.tags = res.entity;
            this.existTags = this.tags.map((tag) => {
              return tag.tag_number;
            });
            this.resourceTagAllList();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取云盘/群盘资源的所有标签
    resourceTagAllList() {
      resourceTagAllList({
        group_number: this.groupNumber,
        disk_type: "cloud",
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.tagList = res.entity.filter((tag) => {
              if (this.existTags.indexOf(tag.tag_number) < 0) {
                return tag;
              }
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 设置文件(夹)标签
    removeTag(tag) {
      let index = this.tags.indexOf(tag);
      this.tags.splice(index, 1);
      this.tagList.push(tag);
    },
    // 设置文件(夹)标签
    addTag(tag) {
      let index = this.tagList.indexOf(tag);
      this.tagList.splice(index, 1);
      this.tags.push(tag);
    },
    // 设置文件(夹)标签
    addTags() {
      let tags = [];
      if (this.newTags) {
        let validObj = null;
        tags = this.newTags
          .split("|")
          .map((tag_name) => {
            return tag_name.trim();
          })
          .filter((item, index, array) => {
            return item && array.indexOf(item) === index;
          })
          .map((item) => {
            if (!validObj || (validObj && validObj.valid)) {
              validObj = verifyTagname(item);
            }
            return item;
          });
        if (!validObj.valid) {
          this.errors.remove("singleTag");
          this.errors.add({
            field: "singleTag",
            msg: validObj.msg,
          });
          return false;
        } else {
          this.errors.remove("singleTag");
        }
      }
      let existTags = [];
      if (this.tags.length) {
        existTags = this.tags.map((item) => item.tag_name);
      }
      handleResourceTag({
        group_number: this.groupNumber,
        action: "replace",
        resources_list: [
          {
            resource_number: this.detail.number,
            resource_type: this.detail.type,
          },
        ],
        tags_list: tags.concat(existTags),
      })
        .then((res) => {
          if (res.status_code === 200) {
            $("#tag").modal("hide");
            this.$message({
              type: "success",
              message: res.message,
            });
            this.newTags = "";
            this.tagList = [];
            this.existTags = [];
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    let that = this;
    $("#tag").on("show.bs.modal", function (e) {
      that.$nextTick(() => {
        that.resourceTagList();
      });
    });
  },
  destroyed() {
    $("#tag").off();
  },
};
</script>

<style scoped>
</style>